/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { BillingCouponRedemption } from './BillingCouponRedemption';
import {
    BillingCouponRedemptionFromJSON,
    BillingCouponRedemptionFromJSONTyped,
    BillingCouponRedemptionToJSON,
    BillingCouponRedemptionToJSONTyped,
} from './BillingCouponRedemption';

/**
 * 
 * @export
 * @interface ListCouponRedemptionsResponse
 */
export interface ListCouponRedemptionsResponse {
    /**
     * 
     * @type {Array<BillingCouponRedemption>}
     * @memberof ListCouponRedemptionsResponse
     */
    data: Array<BillingCouponRedemption>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListCouponRedemptionsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListCouponRedemptionsResponse interface.
 */
export function instanceOfListCouponRedemptionsResponse(value: object): value is ListCouponRedemptionsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListCouponRedemptionsResponseFromJSON(json: any): ListCouponRedemptionsResponse {
    return ListCouponRedemptionsResponseFromJSONTyped(json, false);
}

export function ListCouponRedemptionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCouponRedemptionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BillingCouponRedemptionFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListCouponRedemptionsResponseToJSON(json: any): ListCouponRedemptionsResponse {
      return ListCouponRedemptionsResponseToJSONTyped(json, false);
  }

  export function ListCouponRedemptionsResponseToJSONTyped(value?: ListCouponRedemptionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BillingCouponRedemptionToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

